// services/childcare/refund.js
import { api } from "./utils";

// Get all refund requests (facility admin)
export const getRefundRequests = async (params = {}) => {
  const response = await api.get("/childcare/refund-requests", { params });
  return response;
};

// Get refund request by ID (facility admin)
export const getRefundRequestById = async (id) => {
  const response = await api.get(`/childcare/refund-requests/${id}`);
  return response;
};

// Create refund request (not used by admin — kept for backward compat)
export const createRefundRequest = async (data) => {
  const response = await api.post("/childcare/refund-requests", data);
  return response;
};

// Update refund request notes
export const updateRefundRequest = async (id, data) => {
  const response = await api.put(`/childcare/refund-requests/${id}`, data);
  return response;
};

// Delete refund request
export const deleteRefundRequest = async (id) => {
  const response = await api.delete(`/childcare/refund-requests/${id}`);
  return response;
};

// Process refund request (legacy approve/reject — uses /process endpoint)
export const processRefundRequest = async (id, data) => {
  const response = await api.post(`/childcare/refund-requests/${id}/process`, data);
  return response;
};

// Admin reply to parent
export const addRefundReply = async (id, data) => {
  const response = await api.post(`/childcare/refund-requests/${id}/reply`, data);
  return response;
};

// Update refund status (approve / reject / refunded)
export const updateRefundStatus = async (id, data) => {
  const response = await api.patch(`/childcare/refund-requests/${id}/status`, data);
  return response;
};

// ==================== FACILITY REFUND REQUESTS (aliases) ====================

export const getFacilityRefundRequests = getRefundRequests;
export const getFacilityRefundRequestById = getRefundRequestById;
export const processFacilityRefundRequest = processRefundRequest;
